/*
 * @Author: 曹捷
 * @Date: 2021-01-10 17:18:10
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-09-06 14:28:23
 * @Description: 动态注册 其余sotre
 */
import { Store } from 'obit-wui'
import { name } from './../../package.json';

let store = Store(name)
// store.registerModule('mymodules',{})
export default store
